var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 170,
    height: 170,
    viewBox: "0 0 170 170",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#6dcef8;}.b{fill:#2d3c6b;}.c{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-875 -1550)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-1226.919,9.525h0l-118.795-15.5-.038.05a84.785,84.785,0,0,1-13.1-24.1A84.778,84.778,0,0,1-1363.569-58a85.633,85.633,0,0,1,1.727-17.131,84.565,84.565,0,0,1,4.953-15.956,85,85,0,0,1,7.837-14.439,85.622,85.622,0,0,1,10.379-12.58,85.62,85.62,0,0,1,12.58-10.379,85.01,85.01,0,0,1,14.439-7.837,84.575,84.575,0,0,1,15.955-4.953A85.632,85.632,0,0,1-1278.569-143a85.693,85.693,0,0,1,17.156,1.73,84.537,84.537,0,0,1,15.967,4.961,84.946,84.946,0,0,1,14.44,7.847,85.572,85.572,0,0,1,12.574,10.388,85.62,85.62,0,0,1,10.37,12.585,85.07,85.07,0,0,1,7.826,14.437,84.619,84.619,0,0,1,4.944,15.945A85.592,85.592,0,0,1-1193.569-58a85.275,85.275,0,0,1-2.353,19.919,84.7,84.7,0,0,1-6.7,18.275,85.381,85.381,0,0,1-10.511,16.059,85.57,85.57,0,0,1-13.785,13.272Z",
    transform: "translate(2238.569 1693)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-1231.474,10.505-1341.013-7.479l41.657-132.131a4.8,4.8,0,0,1,1.779-2.47,4.875,4.875,0,0,1,2.833-.92,4.828,4.828,0,0,1,1.45.224l76.353,23.962,7.122,2.235a21.729,21.729,0,0,1,7.6,4.19,21.8,21.8,0,0,1,5.229,6.554,21.8,21.8,0,0,1,2.39,8.037,21.739,21.739,0,0,1-.909,8.638l-1.522,4.824-28.6,90.569c-1.881,1.5-3.85,2.938-5.851,4.274Z",
    transform: "translate(2238.569 1695.277)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-1356.118-5.842V-85.822a4.87,4.87,0,0,1,4.835-4.9h87.487a21.749,21.749,0,0,1,17.91,9.448,22.3,22.3,0,0,1,3.96,12.73V12.8A84.512,84.512,0,0,1-1289,27,84.772,84.772,0,0,1-1356.118-5.842Z",
    transform: "translate(2249 1693)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocs);
export default __webpack_public_path__ + "static/media/docs.1b0cdeca58e2a1dd9804a07852bcba08.svg";
export { ForwardRef as ReactComponent };